import { ComputedRef } from 'vue'

import { ReviewRequestItem } from '@/domain/entities/reviewRequest/reviewRequestItem'
import { JudgeStatusType } from '@/domain/value_objects/judge/JudgeStatusType'
import { DisplayLanguageType } from '@/domain/value_objects/language/displayLanguageType'
import { ReviewRequestViewModel } from '@/presentation/viewmodels/reviewRequest/reviewRequestViewModel'

export class ReviewRequestPresenter {
  private viewModel: ReviewRequestViewModel

  constructor(viewModel: ReviewRequestViewModel) {
    this.viewModel = viewModel
  }

  get reviewRequestList(): ComputedRef<ReviewRequestItem[]> {
    return this.viewModel.reviewRequestList
  }

  get freeDescription(): ComputedRef<string> {
    return this.viewModel.freeDescription
  }

  get reviewJudgeId(): ComputedRef<string> {
    return this.viewModel.reviewJudgeId
  }

  get reviewJudgeStatus(): ComputedRef<JudgeStatusType> {
    return this.viewModel.reviewJudgeStatus
  }

  get isLoading(): ComputedRef<boolean> {
    return this.viewModel.isLoading
  }

  get error(): ComputedRef<Error | null> {
    return this.viewModel.error
  }

  setFreeDescription = (message: string): void => {
    this.viewModel.setFreeDescription(message)
  }

  setReviewRequestData = (judgeId: number, status: JudgeStatusType) => {
    this.viewModel.setReviewJudgeId(judgeId.toString())
    this.viewModel.setReviewJudgeStatus(status)
  }

  getReviewRequestList = async (status: string, displayLanguage: DisplayLanguageType): Promise<void> => {
    await this.viewModel.getReviewRequestList(status, displayLanguage)
  }

  postRegisterEntry = async (
    judgeId: string,
    requests: string[],
    message: string,
    displayLanguage: DisplayLanguageType
  ): Promise<void> => {
    await this.viewModel.postRegisterEntry(judgeId, requests, message, displayLanguage)
  }
}
